<div [attr.data-loaded]="!loading">
    <app-header *ngIf="!isLoginView()"></app-header>
    <app-flash-message [ngClass]="{ hidden: isLoginView() }"></app-flash-message>
    <div class="content" [ngClass]="{ withHeader: !isLoginView() }">
        <router-outlet></router-outlet>
    </div>
    <app-footer *ngIf="!isLoginView()"></app-footer>
</div>
